import { makeStyles } from '@mui/styles';

const WARNING_FONT_SIZE = '13px';
const WARNING_PANEL_MAX_HEIGHT = 200;

const useStyles = makeStyles((theme) => ({
  warningContainer: {
    marginTop: theme.spacing(2),
    padding: 0,
    border: `1px solid ${theme.palette.warning?.light || theme.palette.grey[200]}`,
    backgroundColor: theme.palette.warning.lighter,
    maxHeight: WARNING_PANEL_MAX_HEIGHT,
    overflowY: 'auto',
  },
  warningHeader: {
    padding: theme.spacing(1.5, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
    },
  },
  warningHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  warningIcon: {
    color: theme.palette.warning.dark,
    fontSize: '20px',
    flexShrink: 0,
  },
  warningTitle: {
    fontWeight: 600,
    fontSize: WARNING_FONT_SIZE,
    lineHeight: 1.2,
    color: theme.palette.text.primary,
  },
  warningExpandIcon: {
    color: theme.palette.text.secondary,
    fontSize: 20,
  },
  warningListContainer: {
    padding: theme.spacing(0, 2, 1.5),
  },
  warningListItem: {
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
  },
  warningBullet: {
    minWidth: 20,
  },
  warningBulletIcon: {
    fontSize: 6,
    color: theme.palette.warning.dark,
  },
  warningMessage: {
    fontSize: WARNING_FONT_SIZE,
    color: theme.palette.text.primary,
    lineHeight: 1.4,
  },
  warningInfoNote: {
    display: 'block',
    marginTop: theme.spacing(1.5),
    fontSize: '11px',
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
  },
}));

export default useStyles;
